const basicWindow = {
  outerWidth: 2,
  outerHeight: 2,
}

export default function(data, window = basicWindow) {
  return data
    .filter(d => d.sets.length === 1)
    .map(d => d.sets[0])
    .sort((a,b) => {
      if(a.width === b.width){
        return a.height - b.height
      }
      return a.width - b.width
    })
    .map(d => ({ ...d, position: { x: window.outerWidth / 2, y: window.outerHeight / 2 } }))
}



// WEBPACK FOOTER //
// ./src/actions/products/filterOnlyProducts.js